var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0_476_35)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_476_35",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_476_35",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_476_35",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAABG0lEQVR4nO2VPUpDQRSFPwPp09hFCy1dgbgICUljk8WomEItJLiLlEEQBFNkBdlESIJaiCH6DJGr58ElkC5zsZgDw8y8ucx35s7Pg6ysNDoBBkABzIEecECQWsAXsALegU+1Z8BhBLwQ8AaoAjXgQd96UfApsOvGzMQC+AB2UsNnqkfORFXbYVtTSQnvCDpaM3Gr/nNqeClvYqraVn9MANybKLejUPzW1HRX7XpDzKXGv4GzDN+Gmjnt5AMXeNVa7pHpbojppHpkTBNNbuUFaBAIr2vyV+BJ7aUzkRRuOhXgUf/uC5eJbmq46VyQq9/en4kyE8nhpr5A9zJhmXiLgpvGbrW+TCLg++4ADoE7oA0cEaQasBcFy/oX+gHC8pMH0EF+PAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.4af786eacf8455cdb76fe2af5ce791a9.svg";
export { ForwardRef as ReactComponent };